import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete, exportList } from '@/api/PMS/baseInformation/pakinglotoa';
import { fetchListByType } from '@/api/PMS/dic/dic';
import waves from '@/directive/waves'; // 水波纹指令

import pakinglotoaAdd from './add';
import pakinglotoaBinding from './cgPkOwner';
import pakinglotoaDetail from './detail'; // 导出

import { formatJson } from '@/utils/index'; // 导入弹出框

import importExcel from './import';
export default {
  components: {
    pakinglotoaAdd: pakinglotoaAdd,
    pakinglotoaBinding: pakinglotoaBinding,
    pakinglotoaDetail: pakinglotoaDetail,
    importExcel: importExcel
  },
  directives: {
    waves: waves
  },
  props: ['routerIdArr', 'id', 'flagId', 'activeName', 'isInitSearch'],
  data: function data() {
    return {
      isDetail: false,
      downloadLoading: false,
      list: null,
      total: null,
      listLoading: false,
      initSearch: this.isInitSearch,
      listQuery: {
        page: 1,
        limit: 10,
        parkingCode: '',
        customerName: '',
        isLease: ''
      },
      title: '',
      parkingLotId: '',
      multipleSelection: [],
      rentOption: [],
      dialogFormVisible: false,
      dialogBindingVisible: false,
      dialogDetailVisible: false,
      dialogExcelVisible: false // 导入

    };
  },
  watch: {
    id: function id(val) {
      this.getList();
    },
    flagId: function flagId(val) {
      this.getList();
    },
    activeName: function activeName(val) {
      this.getList();
    }
  },
  created: function created() {
    this.getList();
    this.loadRentControl();
  },
  methods: {
    handleDeletes: function handleDeletes() {
      var parkingLotIds = [];
      this.multipleSelection.forEach(function (row) {
        parkingLotIds.push(row.parkingLotId);
      });
      this.delete(parkingLotIds);
    },
    handCancle: function handCancle(reload) {
      this.getList();
      this.$emit('refreshTree');
      this.$emit('loadMenuTab');

      switch (reload) {
        case true:
          this.dialogExcelVisible = false;
          this.dialogFormVisible = false;
          this.dialogDetailVisible = false;
          this.dialogBindingVisible = false;
          break;

        case 'binding':
          this.dialogBindingVisible = false;
          break;

        case 'offParkAdd':
          this.dialogFormVisible = false;
          break;

        case 'pakingCustomer':
          this.dialogDetailVisible = false;
          this.dialogBindingVisible = true;
          this.title = '绑定业主';
          break;

        case 'pakinglotoaEdit':
          this.title = '编辑';
          this.dialogDetailVisible = false;
          this.dialogFormVisible = true;
          break;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      this.listQuery.dataType = this.flagId;
      this.listQuery.id = this.id;

      if (this.initSearch === true) {
        this.listQuery.parkingCode = '';
        this.listQuery.customerName = '';
        this.listQuery.isLease = '';
      }

      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.initSearch = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.initSearch = false;
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.initSearch = false;
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.initSearch = false;
      this.multipleSelection = val;
    },
    loadRentControl: function loadRentControl() {
      var _this2 = this;

      fetchListByType('is_lease').then(function (r) {
        _this2.rentOption = r.data.data;
      });
    },
    // 创建
    handleCreate: function handleCreate() {
      this.parkingLotId = '';
      this.title = '添加';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(parkingLotId) {
      this.parkingLotId = parkingLotId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    // 绑定业主
    handleBinding: function handleBinding(parkingLotId) {
      this.parkingLotId = parkingLotId;
      this.title = '绑定业主';
      this.dialogBindingVisible = true;
    },
    // 详情
    getItemDetail: function getItemDetail(parkingLotId) {
      this.parkingLotId = parkingLotId;
      this.title = '详情';
      this.dialogDetailVisible = true;
      this.isDetail = true;
    },
    formatJson: function formatJson(filterVal, jsonData) {
      return jsonData.map(function (v) {
        return filterVal.map(function (j) {
          return v[j];
        });
      });
    },
    delete: function _delete(parkingLotIds) {
      var _this3 = this;

      if (parkingLotIds.length > 0) {
        this.$confirm('你确定是要删除这些车位, 是否继续?', '提示').then(function () {
          fetchDelete(parkingLotIds).then(function (response) {
            _this3.getList();

            _this3.$emit('refreshTree');

            _this3.$emit('loadMenuTab');

            _this3.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(parkingLotId) {
      var parkingLotIds = [];
      parkingLotIds.push(parkingLotId);
      this.delete(parkingLotIds);
    },
    // 导出
    handleExport: function handleExport() {
      var _this4 = this;

      var exListQuery = {
        parkingCode: this.listQuery.parkingCode,
        customerName: this.listQuery.customerName,
        dataType: this.listQuery.dataType,
        isLease: this.listQuery.isLease,
        id: this.listQuery.id
      };
      fetchList(exListQuery).then(function (response) {
        _this4.exList = response.data.data;
      });
      this.$confirm('你确定要导出车位数据吗, 是否继续?', '提示').then(function () {
        if (_this4.exList !== null && _this4.exList.length > 0) {
          Promise.resolve().then(function () {
            return _interopRequireWildcard(require('@/vendor/Export2Excel'));
          }).then(function (excel) {
            var tHeader = ['管理区域', '所属车库', '车位号', '车位业主', '车位面积（m²）', '租赁控制', '出售日期', '车牌号1', '车牌2'];
            var fileterVal = ['areaName', 'garageName', 'parkingCode', 'customerName', 'parkingArea', 'isLeaseName', 'saleDate', 'carNumberOne', 'carNumberTwo'];
            var data = formatJson(fileterVal, _this4.exList);
            excel.export_json_to_excel({
              header: tHeader,
              data: data,
              filename: '车位数据',
              autoWidth: true,
              bookType: 'xlsx'
            });
          });
        } else {
          _this4.Alert({
            alertType: 'error',
            message: '暂无数据，无法导出！'
          });
        }
      });
    },
    // 导入
    handleUpload: function handleUpload() {
      this.title = '导入Excel';
      this.dialogExcelVisible = true;
    }
  }
};